import { fromJS } from 'immutable';
import * as salesActions from './salesAction';

let initialState = fromJS({
    isLoading: false,
    salesDashboard: null,
});

const salesReducer = (state = initialState, action) => {
    switch (action.type) {
        case salesActions.IS_LOADING_SALES:
            return state.merge({
                isLoading: action.status,
            });
        case salesActions.SET_SALES_DATA:
            return state.merge({
                salesDashboard: fromJS(action.data),
                isLoading: false,
            });
        default:
            return state;
    }
};

export default salesReducer;